import { LogsTableRow } from '../types';
import { FC } from 'react';
import { DefaultCell } from '@silverfort/sf-components';

type Props = LogsTableRow;

export const TypeCell: FC<Props> = () => {
    return <DefaultCell text={'Authentication'} />;
};
